import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js'
import { createBrowserHistory } from 'history'
import React from 'react'

const browserHistory = createBrowserHistory({ basename: '' })
const reactPlugin = new ReactPlugin()
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: '384faeed-ff64-4125-9a56-506587d12c3f',
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
})
appInsights.loadAppInsights()

/**
 * Component wrapper with AI tracking and component name
 * @param Component
 * @param componentName
 * @returns
 */
const ComponentWrapperWithAITracking = (
  Component: React.ComponentType<any>,
  componentName: string,
) => withAITracking<any>(reactPlugin, Component, componentName, 'appInsights')

export { reactPlugin, appInsights, ComponentWrapperWithAITracking }
